import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { useTheme } from '../providers/ThemeProvider';
import { blogPosts } from '../../data/blogPosts';
export function BlogListPage() {
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  return <div className={`min-h-screen ${isDark ? 'bg-navy-950' : 'bg-white'}`} data-id="element-3270">
      <Navbar data-id="element-3271" />

      <main className="pt-24 pb-16 px-4 sm:px-6 lg:px-8" data-id="element-3272">
        <div className="max-w-5xl mx-auto" data-id="element-3273">
          {/* Page Header */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="mb-12 text-center" data-id="element-3274">
            <h1 className={`text-4xl sm:text-5xl font-serif font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3275">
              Blog
            </h1>
            <p className={`text-lg max-w-2xl mx-auto ${isDark ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-3276">
              Insights, tips, and stories for music teachers building thriving
              studios.
            </p>
          </motion.div>

          {/* Article Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-3277">
            {blogPosts.map((post, index) => <motion.article key={post.slug} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} data-id="element-3278">
                <Link to={`/blog/${post.slug}`} className="group block h-full" data-id="element-3279">
                  <div className={`h-full rounded-xl overflow-hidden border transition-shadow duration-200 ${isDark ? 'bg-navy-900 border-white/10 group-hover:shadow-lg group-hover:shadow-white/5' : 'bg-white border-gray-200 group-hover:shadow-lg group-hover:shadow-gray-200/50'}`} data-id="element-3280">
                    {/* Thumbnail */}
                    <div className="aspect-[16/10] overflow-hidden" data-id="element-3281">
                      <img src={post.thumbnailUrl} alt={post.title} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" loading="lazy" data-id="element-3282" />
                    </div>

                    {/* Content */}
                    <div className="p-5" data-id="element-3283">
                      <p className={`text-xs font-medium uppercase tracking-wider mb-2 ${isDark ? 'text-gray-500' : 'text-gray-400'}`} data-id="element-3284">
                        {post.publishedDate}
                      </p>
                      <h2 className={`text-lg font-semibold mb-2 leading-snug ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3285">
                        {post.title}
                      </h2>
                      <p className={`text-sm leading-relaxed mb-4 line-clamp-3 ${isDark ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-3286">
                        {post.description}
                      </p>
                      <span className={`inline-flex items-center gap-1 text-sm font-medium transition-colors ${isDark ? 'text-blue-400 group-hover:text-blue-300' : 'text-blue-600 group-hover:text-blue-700'}`} data-id="element-3287">
                        Read More
                        <ArrowRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-0.5" data-id="element-3288" />
                      </span>
                    </div>
                  </div>
                </Link>
              </motion.article>)}
          </div>
        </div>
      </main>

      <Footer data-id="element-3289" />
    </div>;
}